// src/infra/api/GraficoApi.js
import api from '../axios';

export const GraficoTipo = {
    SPECTRAL_TURBIDIMETRY: 'SPECTRAL_TURBIDIMETRY',
    SPECTRAL_NEPHELOMETRY: 'SPECTRAL_NEPHELOMETRY',
    SPECTRAL_FLUORESCENCE: 'SPECTRAL_FLUORESCENCE',
    FREQUENCIA: 'FREQUENCIA',
    TEMPERATURA: 'TEMPERATURA',
    TEMPERATURA_SAMPLE: 'TEMPERATURA_SAMPLE',

    // 👇 ADICIONE ESTAS LINHAS
    TEMPERATURA_SAMPLE_CTRL: 'TEMPERATURA_SAMPLE_CTRL',
    TEMPERATURA_CORE_CTRL:   'TEMPERATURA_CORE_CTRL',

    FONTE_ALIMENTACAO: 'FONTE_ALIMENTACAO',
    PASTILHA_PELTIER: 'PASTILHA_PELTIER',
    AGITADOR_MAGNETICO: 'AGITADOR_MAGNETICO',
    CONTROL_STATE: 'CONTROL_STATE',
};

// POST /api/{tenant}/grafico
export async function getGrafico(experimentId, graficoTipo) {
    if (!experimentId) throw new Error('experimentId obrigatório');
    if (!graficoTipo) throw new Error('graficoTipo obrigatório (enum do backend)');
    const { data } = await api.post('/grafico', { experimentId, graficoTipo });
    return data;
}
